import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface TemplateData {
  id: string;
  cmsContentId?: string;
  originTemplateId?: string;
  name: string;
  previewUrl: string;
  width?: number;
  height?: number;
  layers?: any[];
  elements?: any[];
  layerPositions?: Record<string, any>;
  textContents?: Record<string, string>;
  textStyles?: Record<string, any>;
  imageSettings?: Record<string, any>;
  shapeSettings?: Record<string, any>;
  backgroundSettings?: Record<string, any>;
  scrollerSettings?: Record<string, any>;
  isCustom?: boolean;
  category?: string;
}

interface TemplatesState {
  selectedTemplate: TemplateData | null;
}

const initialState: TemplatesState = {
  selectedTemplate: null,
};

export const templatesSlice = createSlice({
  name: 'templates',
  initialState,
  reducers: {
    setSelectedTemplate: (state, action: PayloadAction<TemplateData>) => {
      state.selectedTemplate = action.payload;
    },
    clearSelectedTemplate: (state) => {
      state.selectedTemplate = null;
    },
  },
});
export const { setSelectedTemplate, clearSelectedTemplate } = templatesSlice.actions;

export default templatesSlice.reducer;
